// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__p3ZeV","total":"Cart_total__xC2sB","actions":"Cart_actions__xNfQT","button--alt":"Cart_button--alt__Wv0Qr","button":"Cart_button__n6brH"};